<div class="synthese">
  <h3>{{ 'scenario_project_title' | translate }}</h3>
</div>
<div class="row card text-center">
  <div class="offset-1 col-2">{{ 'common_field_label' | translate }}</div>
  <div class="col-1">{{ 'comparison_energy_mj' | translate }}</div>
  <div class="col-1">{{ 'scenario_project_climate_change' | translate }}</div>
  <div class="col-1">{{ 'scenario_project_natural_aggregates' | translate }}</div>
  <div class="col-1">{{ 'scenario_project_coated_aggregates' | translate }}</div>
  <div class="col-1">{{ 'scenario_project_tkm' | translate }}</div>
  <div class="col-1">{{ 'scenario_project_water_management' | translate }}</div>
  <div class="col-1">{{ 'scenario_project_drc' | translate }}</div>
  <div class="col-1">{{ 'comparison_synthesis' | translate }}</div>
</div>

<div>
  <mat-accordion hideToggle *ngFor="let scenario of scenarios; let i = index">
    <mat-expansion-panel expanded>
      <mat-expansion-panel-header collapsedHeight="*" expandedHeight="*" #panelScenarios (click)="panelScenarios._toggle()">
        <mat-panel-title>
          <div class="row header-projet text-center">
            <div class="col-1">
              <mat-icon (click)="panelScenarios._toggle()">
                {{ panelScenarios._isExpanded() ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}
              </mat-icon>
            </div>
            <div class="col-2">
              {{ scenario?.displayName | localizedLabel: 'synthese' }}
              <mat-icon class="align-icon" (click)="editScenario(scenario)">edit</mat-icon>
              <mat-icon class="align-icon" (click)="deleteScenario(scenarios, i)">delete_outline </mat-icon>
            </div>
            <div class="col-1" *ngFor="let item of scenario.indicatorSelected">
              <mat-checkbox [checked]="item && item.isChecked" disabled></mat-checkbox>
            </div>
            <div class="col-1">
              <button mat-stroked-button class="blue-button" (click)="clickSynthese(scenario)" *ngIf="scenario?.solutions && scenario?.solutions?.length != 0">{{ 'comparison_synthesis' | translate }}</button>
            </div>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="list-solution">
        <div class="row" *ngFor="let solution of scenario?.solutions; let index = index">
          <div class="offset-1 col-2">
            {{ solution.displayName }}
            <mat-icon class="align-icon" (click)="deleteSolution(index, scenario, solution)"> delete_outline </mat-icon>
          </div>
          <div class="col-1 align-icon">
            <mat-icon (click)="editRank(scenario, index, index - 1)" *ngIf="index != 0">arrow_upward </mat-icon>
          </div>
          <div class="col-1 align-icon">
            <mat-icon (click)="editRank(scenario, index, index + 1)" *ngIf="index + 1 != scenario?.solutions?.length">arrow_downward</mat-icon>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="offset-1 col">
          <div class="add-solution">
            <button mat-mini-fab color="accent" class="mini-fab" (click)="addSolution(scenario)">
              <mat-icon>add</mat-icon>
            </button>
            <label class="cursor-pointer" (click)="addSolution(scenario)">{{ 'comparison_add_solution' | translate }}</label>
          </div>
        </div>
      </div>
    </mat-expansion-panel>
  </mat-accordion>

  <div class="row margin-top-10">
    <div class="col card">
      <div class="add-scenario">
        <button mat-mini-fab color="accent" class="mini-fab" (click)="addScenario(scenarios)">
          <mat-icon>add</mat-icon>
        </button>
        <label class="cursor-pointer" (click)="addScenario(scenarios)">{{ 'comparison_create_scenario' | translate }}</label>
      </div>
    </div>
  </div>
</div>
